import { render, staticRenderFns } from "./returnInformation.vue?vue&type=template&id=b3307bca"
import script from "./returnInformation.vue?vue&type=script&lang=js"
export * from "./returnInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports